import request from "superagent";
import { Event } from "react-big-calendar";
import moment from "moment";

let GOOGLE_CALENDAR_URL = `https://www.googleapis.com/calendar/v3/calendars/hk@hkserv.ugent.be/events?key=AIzaSyAvEyDBeBLTXtJP0XCWPfBkQV_jOuvd3LE&showDeleted=false&timeMin=${new Date().toISOString()}`;
console.log(GOOGLE_CALENDAR_URL);
export function getEvents(callback: (arg0: any[]) => void) {
  request
    .get(GOOGLE_CALENDAR_URL)
    .end((err: any, resp: { body: { items: any[] } }) => {
      if (!err) {
        const events: Event[] = [];
        resp.body.items
          .filter(
            (event: {
              start?: { dateTime: string };
              end?: { dateTime: string };
              summary: any;
            }) => {
              return event.start && event.end;
            }
          )
          .map(
            (event: {
              start: { dateTime: string };
              end: { dateTime: string };
              summary: any;
            }) => {
              return events.push(createEvent(event));
            }
          );
        callback(events);
      }
    });
}

const createEvent = (event: any): Event => {
  if (event.start.dateTime) {
    return {
      start: new Date(event.start.dateTime),
      end: new Date(event.end.dateTime),
      title: event.summary,
    };
  } else {
    return {
      start: new Date(event.start.date),
      end: moment(event.end.date).subtract({day: 1}).toDate(),
      title: event.summary,
    };
  }
};
